<template>
  <div class="card-business-container">
    <header>
      <span class="title">名片小程序</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-date-picker size="small" v-model="daterange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" @change="dataChange"></el-date-picker>
        <el-button type="primary" @click="statusChange(1)" :disabled="disabled">启用</el-button>
        <el-button @click="statusChange(0)" :disabled="disabled">禁用</el-button>
      </div>
    </header>
    <!-- 手机号码、姓名、所属公司、部门、职位、邮件、注册时间、状态； -->
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @selection-change='handleSelectionChange'>
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop="phone" label="手机号码" min-width="120"></el-table-column>
      <el-table-column prop="user_name" label="姓名" min-width="120"></el-table-column>
      <el-table-column prop="company_name" label="所属公司" min-width="140"></el-table-column>
      <el-table-column prop="department_name" label="部门" min-width="120"></el-table-column>
      <el-table-column prop="post_name" label="职位" min-width="100"></el-table-column>
      <el-table-column prop="email" label="邮件" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="register_time" label="注册时间" min-width="140">
        <template slot-scope="scope">{{ scope.row.register_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100"></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <!-- <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">禁用</div>
      <div class="note">删除后该消息将不可用。</div>
      <div class="prompt">确定要删除该消息吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import mixin from '@/common/js/mixins.js'

export default {
  data () {
    return {
      daterange: '',
      disabled: true,
      tableList: [],
      moduleId: 19,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      searchInput: '',
      dialogStatus: false
    }
  },
  mixins: [mixin],
  created () {
  },
  /* 页面加载后执行 */
  mounted () {
    // this.queryFchBtnAuth(({moduleId: this.moduleId}))
    this.getBusinessCardList()
  },
  methods: {
    /** 获取平台消息列表 */
    getBusinessCardList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'searchText': this.searchValue}
      if (this.daterange) {
        jsondata.searchTime = {
          startTime: this.daterange[0],
          endTime: this.daterange[1]
        }
      }
      console.log(jsondata)
      this.$http.getBusinessCardList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getBusinessCardList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.getBusinessCardList()
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.getBusinessCardList()
    },
    // 时间区间筛选
    dataChange () {
      console.log(this.daterange)
      this.pageNum = 1
      this.pageSize = 20
      this.getBusinessCardList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    // 禁用/启用
    statusChange (status) {
      console.log(this.multipleSelection)
      let arr = []
      let openId = []
      this.multipleSelection.map(v => {
        arr.push(v.id)
        openId.push(v.open_id)
      })
      let jsondata = {
        ids: arr.toString(),
        open_id: openId.toString(),
        status: status
      }
      console.log(jsondata)
      this.$http.enableDisableCard(jsondata, 'Loading').then((res) => {
        this.$message.success('保存成功！')
        this.getBusinessCardList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-business-container{
  .el-range-editor{
    width: 240px;
    margin-left: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/program/business.vue